import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import LabelFont from '../../../Theme/Fonts/Label'

export type BasicLabelProps = {
    /** label text */
    children: string
    /** flag to render the live dot */
    isLive?: boolean
    /** the labels backgroundColor */
    backgroundColor?: 'ORANGE' | 'onyx' | 'pearl' | 'BLACK'
    /** labels fontColor */
    fontColor?: 'pearl' | 'onyx' | 'WHITE'
}

const Label: FunctionComponent<BasicLabelProps> = ({
    children,
    backgroundColor = 'BLACK',
    fontColor = 'WHITE',
    isLive,
}): ReactElement => {
    return (
        <Grid horizontal noExpand>
            <Grid
                horizontal
                noExpand
                height={18}
                paddingLeft={3}
                paddingRight={3}
                backgroundColor={backgroundColor}
                borderRadius={1}
                center
            >
                {isLive ? (
                    <Grid
                        noExpand
                        borderRadius={4}
                        backgroundColor="WHITE"
                        width={6}
                        height={6}
                        marginRight={2}
                    />
                ) : null}
                <LabelFont color={fontColor} uppercase bold>
                    {children}
                </LabelFont>
            </Grid>
        </Grid>
    )
}

export default memo(Label)
